/* eslint-disable no-useless-return */
import Plugin from './components/message.vue';

export default class Confirm {
  static confirms: Array<{
    msg: string,
    options?: any,
    resolve: any,
    reject: any,
  }> = [];

  static doing: boolean = false;

  private defaultOpts: any = {
    handleClickModal: false,
    handleEscModal: false,
  };

  private instance: any;

  constructor(instance: any) {
    /* eslint-disable no-console */
    if (!instance) console.error('Vue instance is not defined');
  }

  public install(msg: string, options: any) {
    const confirm = new Promise((resolve, reject) => {
      Confirm.confirms.push({
        msg,
        options: { ...options, ...this.defaultOpts },
        resolve,
        reject,
      });
      this.eventLoop();
    });
    return confirm;
  }

  confirm(msg: string, options: any = {}) {
    return new Promise((resolve, reject) => {
      this.instance = new Plugin({
        el: document.createElement('div'),
        data: {
          message: msg,
          ...options,
        },
      });
      document.body.appendChild(this.instance.$el);
      this.instance.$on('close', (type: string) => {
        /* eslint-disable default-case */
        switch (type) {
          /* eslint-disable prefer-promise-reject-errors */
          case 'Cancel': reject('Cancel'); break;
          case 'Close': reject('Close'); break;
          case 'Loading': {
            this.confirm('正在执行中... 请耐心稍等...', {
              hasCancelButton: false,
              confirmButtonText: '知道啦',
            }).then(() => this.instance.close());
            break;
          }
          case 'OK': resolve();
        }
      });
    });
  }

  eventLoop() {
    if (Confirm.doing || Confirm.confirms.length === 0) return;
    Confirm.doing = true;
    const item: any = Confirm.confirms.shift();
    this.confirm(item.msg, item.options).then(() => {
      if (this.instance.loading) item.resolve(this.instance.close);
      else item.resolve();
      Confirm.doing = false;
      this.eventLoop();
    }).catch((err: Error) => {
      item.reject(err.message);
      Confirm.doing = false;
      this.eventLoop();
    });
  }
}
